import { useQuery } from '@tanstack/react-query'
import { webTicketList } from '../index'

const useWebTicketList = (currentPage: number, limit: number) => {
  return useQuery({
    queryKey: ['webTicketList', currentPage, limit],
    queryFn: webTicketList,
    enabled: !!currentPage && !!limit,
  })
}

export default useWebTicketList
